import React from 'react'
import styled from 'styled-components';
import Stars from '../../icons/Stars.svg'


const StyledWrapper = styled.section`
    padding-top: 5rem; 

    p {
        font-size: 28px;
    }

    @media (max-width: 768px) {
        padding-top: 3rem; 
        p { font-size: 18px; }
        svg { width: 75%; }
    }
`;

const Statement = () => {
    return (
        <StyledWrapper>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className='mb-md-5 mb-3'>One for All, and <br/>All for One</h2>
                        <p>
                            Together, at Niro, our force equals the sum of all our people. With extensive experience across fintech, financial services, gaming, consumer and education - we know what it takes to succeed.
                        </p>
                    </div>
                    <div className="col-md-6 d-flex justify-content-center py-3">
                        <Stars />
                    </div>
                </div>
            </div>
        </StyledWrapper>
    )
}


export default Statement
